import { Suspense } from 'react'
import { PrescribingHistoryTable } from './table'
import LoadingSpinner from '@/components/ui/icons/loading-spinner'
import { useMedRequestHistoryCount } from '@/lib/api/med-requests/history'

export default function PrescribingHistoryPage() {
  const { data: total } = useMedRequestHistoryCount()

  return (
    <section className='flex flex-col gap-8'>
      <div className='flex items-start justify-between'>
        <div className='flex flex-col gap-2'>
          <h2 className='capitalize text-[2rem] font-semibold leading-10 text-secondary'>Prescribing History</h2>

          <p className='leading-6 text-sm font-normal text-custom-neutral-500'>
            View the most recent {total} prescriber actions.
          </p>
        </div>
      </div>
      <Suspense fallback={<LoadingSpinner />}>
        <PrescribingHistoryTable />
      </Suspense>
    </section>
  )
}
